// extracted by mini-css-extract-plugin
export var menuItem = "K_wz g_gV g_cD g_cH g_cS g_C";
export var menuItemSub = "K_wB g_b5 g_cD g_cS";
export var menuMainLink = "K_wC g_gW g_fF";
export var menuLink = "K_wD g_gW g_fF";
export var icon = "K_qf g_cG g_cS";
export var divider = "K_wF g_cG g_cS";
export var sublinks = "K_wG";
export var link = "K_v";
export var Link = "K_s1 y_s1 y_sl y_sG";